import { useQuery } from '@tanstack/react-query'
import { validateTimeRange } from '../utils/dateUtils'
import { fetchHistoricalConfigs } from '../utils/api'

const fetchConfigSnapshotsQueryFn = async ({ queryKey, signal }) => {
  const [, timeRange] = queryKey
  let validatedTimeRange
  try {
    validatedTimeRange = validateTimeRange(timeRange)
  } catch {
    return [] 
  }

  if (!validatedTimeRange?.startTime || !validatedTimeRange?.endTime) {
    return []
  }

  const { startTime, endTime } = validatedTimeRange
  const resp = await fetchHistoricalConfigs(startTime, endTime, signal)
  return Array.isArray(resp?.data) ? resp.data : []
}

export function useConfigSnapshots(timeRange, showConfigChanges) {
  const { 
    data, 
    isLoading, 
    error, 
  } = useQuery({
    queryKey: ['configSnapshots', timeRange],
    queryFn: fetchConfigSnapshotsQueryFn,
    enabled: showConfigChanges && !!timeRange,
    staleTime: 1000 * 60 * 5,
  })

  return {
    configSnapshots: data || [],
    configLoading: isLoading,
    configError: error?.message || null,
  }
}
